module.exports = __webpack_public_path__ + "img/cookie.ee6f7d2f.jpeg";